import React, { useState } from 'react'
import clsx from 'clsx'
import {
  FormControlLabel,
  Radio,
  Typography,
  RadioGroup,
  FormControl,
  Grid,
  Fade,
} from '@material-ui/core'
import ErrorIcon from '@material-ui/icons/Error'
import Button from '../Button/Button'
import CMSText, { prismicText } from '../Global/CMSText'
import useTakeBackStyle from '../../components/TakeBack/TakeBack.style'
import { PrismicTakeBackData } from '@/interfaces/common/prismicTakeBack'
import { ConfirmationDialog } from '@/components/Dialog'

type Tprops = {
  data: PrismicTakeBackData
  t: any
  handleResponseFirstPart: any
  error: any
  disabledButtonFirstPart: any
  handleShowSecondPart: any
  takeBackProductsInformations: any
  currentProductIndex: any
}

const TakeBackFirstStepFirstPart = ({
  data,
  t,
  handleResponseFirstPart,
  error,
  disabledButtonFirstPart,
  handleShowSecondPart,
  takeBackProductsInformations,
  currentProductIndex,
}: Tprops) => {
  const classes = useTakeBackStyle()
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false)

  const handleShowConfirmationDialog = (shown: boolean) => () => {
    setShowConfirmationDialog(shown)
  }

  const handleConfirmation = () => {
    if (data?.show_confirmation) {
      setShowConfirmationDialog(true)
    } else {
      handleShowSecondPart()
    }
  }

  const submitConfirmation = () => {
    setShowConfirmationDialog(false)
    handleShowSecondPart()
  }

  return (
    <>
      <form>
        <Typography
          variant="h3"
          component="h2"
          className={clsx(
            classes.preliminaryQuestionTitle,
            'takeBack__preliminaryQuestion__title'
          )}
        >
          <CMSText
            asText
            data={data?.question_title}
            defaultText={t('texts:takeBack:question_title')}
          />
        </Typography>
        <div>
          {data?.questions.map((question, index) => {
            return (
              <Grid
                container
                spacing={0}
                alignItems="center"
                wrap="nowrap"
                key={index}
                className={clsx(
                  classes.preliminaryQuestion,
                  classes.marginBottom,
                  'takeBack__preliminaryQuestion'
                )}
              >
                <Grid
                  item
                  xs={'auto'}
                  className={classes.preliminaryQuestionCol}
                >
                  <Typography
                    variant="body1"
                    component="div"
                    className={clsx(
                      classes.preliminaryQuestionText,
                      'takeBack__preliminaryQuestion__text'
                    )}
                  >
                    <CMSText
                      data={question.question}
                      defaultText={t('texts:takeBack:condition_question')}
                    />
                    {question.is_required && (
                      <span
                        className={clsx(
                          classes.preliminaryQuestionRequired,
                          'takeBack__preliminaryQuestion__required'
                        )}
                      >
                        *
                      </span>
                    )}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={'auto'}
                  className={clsx(
                    classes.preliminaryQuestionAnswer,
                    'radio',
                    'takeBack__preliminaryQuestion__answer'
                  )}
                >
                  <FormControl required={question.is_required}>
                    <RadioGroup
                      row
                      onChange={(event) =>
                        handleResponseFirstPart(event, index)
                      }
                      defaultValue={
                        takeBackProductsInformations[currentProductIndex]
                          .answers[index].answer
                      }
                    >
                      <FormControlLabel
                        name={prismicText(question?.question)}
                        value="true"
                        control={<Radio color="primary" />}
                        label={t(
                          'texts:takeBack:positive_response_to_preliminary_questions'
                        )}
                        labelPlacement={'end'}
                      />
                      <FormControlLabel
                        name={prismicText(question?.question)}
                        value="false"
                        control={<Radio color="primary" />}
                        label={t(
                          'texts:takeBack:negative_response_to_preliminary_questions'
                        )}
                        labelPlacement={'end'}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            )
          })}
        </div>
        <Typography
          component="p"
          className={clsx(
            classes.firstStepTextRequired,
            'takeBack__required-field'
          )}
        >
          <CMSText
            asText
            data={data?.required_field}
            defaultText={t('texts:takeBack:required_field')}
          />
        </Typography>
        {error && (
          <Fade in>
            <Typography
              variant="body1"
              component="div"
              className={clsx(
                'takeBack__error',
                classes.preliminaryQuestionsError,
                classes.error,
                classes.marginBottom
              )}
            >
              <ErrorIcon color="inherit" />
              <CMSText
                data={data?.error_message}
                defaultText={t('texts:takeBack:error_message')}
              />
            </Typography>
          </Fade>
        )}
        <div className={clsx(classes.center, 'takeBack__firstStep__submit')}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={handleConfirmation}
            disabled={disabledButtonFirstPart}
            className={classes.buttonNextPart}
          >
            <CMSText
              asText
              data={data?.next_step_button}
              defaultText={t('texts:takeBack:next_step_button')}
            />
          </Button>
        </div>
      </form>
      {data?.show_confirmation && (
        <ConfirmationDialog
          open={showConfirmationDialog}
          onConfirm={submitConfirmation}
          onClose={handleShowConfirmationDialog(false)}
          title={data?.first_confirmation_title}
          body={data?.first_confirmation_body}
          confirmText={data?.first_confirmation_button_label}
        />
      )}
    </>
  )
}

export default TakeBackFirstStepFirstPart
